"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("settings-content-modals/EmailCreationModal/modalInteractions/actions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  emailCreationModalData: {},
  emailCreationModalOpen: false,
  emailCreationModalType: null
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.ModalActionTypes.OPEN_EMAIL_CREATION_MODAL, function (state, action) {
  var _action$payload$modal = action.payload.modalData,
      type = _action$payload$modal.type,
      data = (0, _objectWithoutProperties2.default)(_action$payload$modal, ["type"]);
  return state.set('emailCreationModalOpen', true).set('emailCreationModalType', type).set('emailCreationModalData', data);
}), (0, _defineProperty2.default)(_handleActions, _actions.ModalActionTypes.CLOSE_MODAL, function (state) {
  return state.merge({
    emailCreationModalOpen: false,
    emailCreationModalType: null,
    emailCreationModalData: {}
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;